var _defs, _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Confidence",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d2d2d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a8a8a8"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_328",
    "data-name": "Ellipse 328",
    cx: 12.305,
    cy: 12.305,
    r: 12.305,
    transform: "translate(32.695 15.82)",
    fill: "url(#linear-gradient)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15684",
    "data-name": "Path 15684",
    d: "M243.637,10.547a2.637,2.637,0,0,0,2.637-2.637V2.637a2.637,2.637,0,0,0-5.273,0V7.91A2.637,2.637,0,0,0,243.637,10.547Z",
    transform: "translate(-198.637)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15685",
    "data-name": "Path 15685",
    d: "M163.988,29.956a2.637,2.637,0,1,0,4.567-2.637l-2.637-4.567a2.637,2.637,0,1,0-4.567,2.637Z",
    transform: "translate(-132.698 -17.666)",
    fill: "url(#linear-gradient)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15686",
    "data-name": "Path 15686",
    d: "M103.752,84.918l4.567,2.637a2.637,2.637,0,0,0,2.637-4.567l-4.567-2.637a2.637,2.637,0,1,0-2.637,4.567Z",
    transform: "translate(-84.427 -65.936)",
    fill: "url(#linear-gradient)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15687",
    "data-name": "Path 15687",
    d: "M353.935,86.59a2.637,2.637,0,0,0,3.6.965l4.567-2.637a2.637,2.637,0,0,0-2.637-4.567L354.9,82.988A2.637,2.637,0,0,0,353.935,86.59Z",
    transform: "translate(-291.428 -65.936)",
    fill: "url(#linear-gradient)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15688",
    "data-name": "Path 15688",
    d: "M307.317,30.921a2.637,2.637,0,0,0,3.6-.965l2.637-4.567a2.637,2.637,0,1,0-4.567-2.637l-2.637,4.567A2.637,2.637,0,0,0,307.317,30.921Z",
    transform: "translate(-252.209 -17.666)",
    fill: "url(#linear-gradient)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15689",
    "data-name": "Path 15689",
    d: "M74.457,158.125v23.2h33.4v-23.2a18.457,18.457,0,0,0,18.457-18.457v-4.395a5.273,5.273,0,1,0-10.547,0v4.395a7.91,7.91,0,0,1-7.91,7.91H103.7a17.547,17.547,0,0,1-25.08,0H74.457a7.91,7.91,0,0,1-7.91-7.91v-4.395a5.273,5.273,0,1,0-10.547,0v4.395A18.457,18.457,0,0,0,74.457,158.125Z",
    transform: "translate(-46.156 -107.148)",
    fill: "url(#linear-gradient)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15690",
    "data-name": "Path 15690",
    d: "M87.363,452H2.637A2.637,2.637,0,0,0,0,454.637v5.273a2.637,2.637,0,0,0,2.637,2.637H87.363A2.637,2.637,0,0,0,90,459.91v-5.273A2.637,2.637,0,0,0,87.363,452Z",
    transform: "translate(0 -372.547)",
    fill: "url(#linear-gradient)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidence);
export default __webpack_public_path__ + "static/media/Confidence.7a19db4a14853c8c0403764f9bbeb0e6.svg";
export { ForwardRef as ReactComponent };